var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.501,
    r: 7.188
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.501,
    r: 3.75,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.8,
    d: "M13.389 3.379L10.884 5.884M9.117 4.116L11.629 1.603M3.378 13.39L5.883 10.885M4.116 9.117L1.611 11.623M11.626 13.387L9.122 10.883M10.887 9.113L13.393 11.618M1.614 3.374L4.117 5.879M5.888 4.113L3.382 1.607"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWheel);
export default __webpack_public_path__ + "static/media/help-wheel.c6062fa71c8fa985f7e16d6c5a10982b.svg";
export { ForwardRef as ReactComponent };